import { AxiosResponse } from 'axios';
import axios from './axios';

export const submitMessage = (name: string, email: string, message: string, receive: boolean): Promise<AxiosResponse> =>
  axios.post('/contactus', { name, email, message, receive });

export default {
  submitMessage,
};
